// Contatti e link social ufficiali Drago Ramen
export const CONTACTS = {
  address: "Corso Sicilia 7 e 9",
  city: "95131 Catania (CT)",
  cell: "3444174626",
  cellFormatted: "+39 344 417 4626",
  cellIntl: "393444174626", // per wa.me/tel:
  fixed: "0954235911",
  fixedFormatted: "+39 095 423 5911",
  vat: "IT06115620871",
  hours: [
    { label: "Tutti i giorni", value: "11:00 – 24:00" },
  ],
  social: {
    facebook: "https://www.facebook.com/dragoramencatania",
    instagram: "https://www.instagram.com/dragoramencatania/",
    tiktok: "https://www.tiktok.com/@dragoramen",
  },
  delivery: {
    justeat: "https://www.justeat.it/restaurants-ristorante-drago-catania/menu",
    glovo: "https://glovoapp.com/it/it/catania-acireale/stores/ristorante-cinese-da-antonio-cat",
  },
  googleMapsPlace: "Corso Sicilia 7 Catania",
  googleReviewsUrl: "https://maps.app.goo.gl/uEwq7YvHxBbqnHy28",
  googleMapsDirUrl: "https://maps.app.goo.gl/uEwq7YvHxBbqnHy28",
};
